import React from 'react';
import './style.scss';

export interface AchievementPopupData {
  id: string;
  titulo: string;
  imagem?: string;
  position: number;
  total: number;
}

interface AchievementPopupProps {
  achievement: AchievementPopupData;
  onClose: () => void;
}

export const AchievementPopup: React.FC<AchievementPopupProps> = ({
  achievement,
  onClose
}) => {
  return (
    <div className="achievement-popup-overlay" role="status" aria-live="polite">
      <div className="achievement-popup">
        <button
          className="achievement-popup__close"
          onClick={onClose}
          aria-label="Fechar feedback de conquista"
        >
          ×
        </button>

        {achievement.total > 1 && (
          <div className="achievement-popup__counter">
            {achievement.position}/{achievement.total}
          </div>
        )}

        <div className="achievement-popup__content">
          <div className="achievement-popup__image-wrapper">
            {achievement.imagem ? (
              <img
                src={achievement.imagem}
                alt={`Badge ${achievement.titulo}`}
                className="achievement-popup__image"
              />
            ) : (
              <div className="achievement-popup__image achievement-popup__image--fallback" aria-hidden="true">
                🏅
              </div>
            )}
          </div>

          <p className="achievement-popup__label">Nova conquista desbloqueada</p>
          <h3 className="achievement-popup__title">{achievement.titulo}</h3>
          <p className="achievement-popup__description">Parabéns! Você conquistou um novo badge.</p>
        </div>
      </div>
    </div>
  );
};
